import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger
} from '../ui/dropdown-menu';
import { Sun, Moon, Monitor } from 'lucide-react';

export function Header({ title }) {
    const { theme, setTheme } = useTheme();
    const { user } = useAuth();

    const themeIcon = {
        light: <Sun className="h-4 w-4" />,
        dark: <Moon className="h-4 w-4" />,
        system: <Monitor className="h-4 w-4" />
    };

    return (
        <header className="h-14 border-b border-border bg-background/95 backdrop-blur-sm sticky top-0 z-30 px-6 flex items-center justify-between">
            <div className="flex items-center gap-3">
                <h1 className="text-xl font-bold tracking-tight text-foreground">{title}</h1>
            </div>

            <div className="flex items-center gap-2">
                <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-muted text-xs text-muted-foreground font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                    {user?.name}
                </div>

                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="outline" size="icon" className="h-8 w-8 border-border" data-testid="theme-toggle">
                            {themeIcon[theme]}
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-36">
                        <DropdownMenuItem onClick={() => setTheme('light')} data-testid="theme-light" className={theme === 'light' ? 'bg-accent' : ''}>
                            <Sun className="h-4 w-4 mr-2" /> Light
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={() => setTheme('dark')} data-testid="theme-dark" className={theme === 'dark' ? 'bg-accent' : ''}>
                            <Moon className="h-4 w-4 mr-2" /> Dark
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={() => setTheme('system')} data-testid="theme-system" className={theme === 'system' ? 'bg-accent' : ''}>
                            <Monitor className="h-4 w-4 mr-2" /> System
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </header>
    );
}
